var map = {
	"./application.svg": 8702,
	"./atom.svg": 4551,
	"./blue-close.svg": 1767,
	"./breadcrumbs.svg": 5990,
	"./btn-allread.svg": 1466,
	"./btn-delete.svg": 4896,
	"./btn-excel.svg": 9370,
	"./btn-lock.svg": 2428,
	"./btn-printer.svg": 3135,
	"./btn-save.svg": 3130,
	"./btn-search.svg": 4761,
	"./card-bulleted.svg": 3768,
	"./cash-multiple.svg": 4774,
	"./chart-bar.svg": 2132,
	"./chart-box.svg": 5420,
	"./circle-medium.svg": 4120,
	"./clipboard-check.svg": 3429,
	"./clipboard-list.svg": 9483,
	"./clock-time-eight.svg": 7618,
	"./close-circle.svg": 6125,
	"./cube-outline.svg": 9966,
	"./email-open-outline.svg": 7696,
	"./email-variant.svg": 5276,
	"./home-circle.svg": 8246,
	"./icon-list.svg": 1320,
	"./icon-search.svg": 7852,
	"./menu.svg": 6833,
	"./pencil-box.svg": 9375,
	"./scm/account-outline.svg": 6254,
	"./scm/logout.svg": 1112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9832;